// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__1jpRz","bgBlue":"style_bgBlue__1ZENi","bgCream":"style_bgCream__2ay0o","caption":"style_caption__1smI8"};